// src/app/services/hit-test.service.ts
import { effect, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { store } from '../../../jmkw.store';
import { JepHitTestResult, JepViewClickEvent } from '@jeppesen-foreflight/jmkw-types';
import * as normalizeUtils from '@arcgis/core/geometry/support/normalizeUtils';
import type { ViewHitTestResult } from "@arcgis/core/views/types";

@Injectable({
  providedIn: 'root'
})
export class HitTestService {
  private readonly _hitTest = new Subject<JepHitTestResult>();

  get hitTest$() {
    return this._hitTest.asObservable();
  }

  constructor() {
    effect(() => {
      const loaded = store.state?.viewsLoaded();
      if (loaded) {
        this.addMapViewClickHandler();
      }
    });
  }

  addMapViewClickHandler() {
    const view = store.views['2D'].view();
    view.on('click', (event: JepViewClickEvent) => {
      // normalize any dateline-crossing mapPoint
      const normalizedPoint = normalizeUtils.normalizeCentralMeridian([
        event.mapPoint
      ]);
      normalizedPoint.then((geometries) => {
        const normalizedEvent = {
          ...event,
          mapPoint: geometries[0] // Use the first geometry from the resolved promise
        } as JepViewClickEvent;

        view.hitTest(normalizedEvent).then((results: ViewHitTestResult) => {
          const response = {
            ...results,
            event: normalizedEvent
          };
          this._hitTest.next(response);
        });
      });
    });
  }
}
